"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var create_exports = {};
__export(create_exports, {
  autoBuckets: () => autoBuckets,
  enumBuckets: () => enumBuckets,
  lookupBucket: () => lookupBucket,
  nullableEnumBuckets: () => nullableEnumBuckets,
  rangeBucket: () => rangeBucket,
  standardBuckets: () => standardBuckets
});
module.exports = __toCommonJS(create_exports);
var import_marker = require("../marker/index.js");
function lookupBucket(value, marker2, label) {
  return { type: "LookupBucket", label, value, marker: marker2 };
}
function rangeBucket(minValue, maxValue, marker2, label, maxInclusive = false) {
  return {
    type: "RangeBucket",
    label,
    minValue,
    maxValue,
    maxInclusive,
    marker: marker2
  };
}
function autoBuckets(props) {
  return { type: "AutoBuckets", ...props };
}
function standardBuckets(buckets) {
  return { type: "StandardBuckets", buckets };
}
function enumBuckets(source, markers, noneValue) {
  const entries = Array.isArray(source) ? source : source.entries;
  return standardBuckets(
    entries.map(
      (entry, index) => noneValue != null && entry.value === noneValue ? lookupBucket(entry.value, import_marker.marker.empty, entry.label) : lookupBucket(entry.value, markers?.[entry.value] ?? import_marker.marker.hue(360 * index / entries.length), entry.label)
    )
  );
}
function nullableEnumBuckets(source) {
  const entries = Array.isArray(source) ? source : source.entries;
  return standardBuckets([
    ...entries.map(
      (entry, index) => lookupBucket(entry.value, import_marker.marker.hue(360 * index / entries.length), entry.label)
    ),
    lookupBucket(null, import_marker.marker.empty, "(blank)")
  ]);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  autoBuckets,
  enumBuckets,
  lookupBucket,
  nullableEnumBuckets,
  rangeBucket,
  standardBuckets
});
//# sourceMappingURL=create.js.map
